import { useContext, useEffect, useRef, useState } from "react";
import { ReactComponent as DefaultUser } from '../../assets/svg/default_user_black.svg';
import { CommonTexts as Texts } from '../../helpers/LayoutTexts';
import { getCandidateProfileImageUrl } from "../../services/RecruiterService";
import { AuthContext } from "../../providers/AuthContextProvider";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";

interface Props {
    candidateId: number;    
    style?: React.CSSProperties;
}

export const LazyProfileImage: React.FC<Props> = ({ candidateId, style }) => {
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const [src, setSrc] = useState<string | null>(null);
    const wrapperRef = useRef<HTMLSpanElement>(null);
    const fetched = useRef(false);

    useEffect(() => {
        if(recruiter === null) return;

        const el = wrapperRef.current;
        if (!el) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !fetched.current) {
                fetched.current = true;
                observer.disconnect();
                getCandidateProfileImageUrl(candidateId, recruiter.recruiterId, recruiter.token)
                    .then(setSrc)
                    .catch(() => {});
            }
        }, { threshold: 0 });

        observer.observe(el);
        return () => observer.disconnect();
    }, [candidateId]);

    return (
        <span ref={wrapperRef} style={{ display: 'inline-flex' }}>
            {src ? (
                <img src={src} style={style} onError={(e) => { e.currentTarget.src = Texts.defaultUser; }} />
            ) : (
                <DefaultUser style={style} />
            )}
        </span>
    );
};
